export default __webpack_public_path__ + "static/media/6.b136aba9.png";